import DetailsComponent from './DetailsComponent';
import { history } from '../../contants';
import styled from 'styled-components';

const HistoryDetails = () => {
  return (
    <DetailsComponent>
      <Wrapper>
        <Header>{history.title}</Header>
      </Wrapper>
      <Description>
        <ul>
          {history.content.map((points, index) => (
            <List key={index}>{points.description}</List>
          ))}
        </ul>
      </Description>
    </DetailsComponent>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
`;

const Header = styled.h1`
  font-family: 'Bashing';
  font-size: calc(70 / 16 * 1rem);
  line-height: 26px;
  letter-spacing: 0.5px;
  font-weight: 400;
  margin-bottom: 8px;
  line-height: 68px;
`;

const Description = styled.div`
  flex: 1;
  font-family: 'Raleway';
  line-height: 26px;
  letter-spacing: 0.5px;
  font-weight: 400;
  text-align: left;
`;

const List = styled.ul`
  margin-bottom: 16px;
  font-family: 'Raleway';
  letter-spacing: 0.5px;
  font-weight: 500;
  line-height: 26px;
`;

export default HistoryDetails;
